import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
};

export const getCustomerData = async () => {
    const response = await axios.get(`${API_URL}/customer`, getAuthHeaders());
    return response.data;
};

export const getCustomerCustomFields = async (centerId) => {
    try {
        const response = await axios.get(
            `${API_URL}/centers/${centerId}/custom-lead-fields`,
            getAuthHeaders()
        );

        // Handle 204 No Content - backend returns this for empty lists
        if (response.status === 204 || !response.data) {
            return { definitions: [] };
        }

        return response.data;
    } catch (error) {
        // Handle 404 - endpoint might not exist yet
        if (error.response?.status === 404) {
            return { definitions: [] };
        }

        // Handle 204 in error path (some axios versions treat 204 as error)
        if (error.response?.status === 204) {
            return { definitions: [] };
        }

        throw error;
    }
};

export const upsertCustomFieldDefinitions = async (centerId, definitionData) => {
    const response = await axios.post(
        `${API_URL}/centers/${centerId}/custom-lead-fields`,
        definitionData,
        getAuthHeaders()
    );
    return response.data;
};

const customerService = {
    getCustomerData,
    getCustomerCustomFields,
    upsertCustomFieldDefinitions,
};

export default customerService;
